import { createStore } from "redux";
import { devToolsEnhancer } from "redux-devtools-extension";
import { bookReducer } from "./reducers/bookReducer";

function configureStore() {
  return createStore(bookReducer, devToolsEnhancer());
}

export default configureStore;
